import { env } from '@/lib/env';

// Validate Google Maps API key
if (!env.VITE_GOOGLE_MAPS_API_KEY) {
  console.warn('⚠️ Google Maps API key is missing. Map features will be disabled.');
}

export const MAPS_CONFIG = {
  defaultCenter: {
    lat: 40.7128,
    lng: -74.0060
  },
  defaultZoom: 12,
  apiKey: env.VITE_GOOGLE_MAPS_API_KEY,
  isEnabled: Boolean(env.VITE_GOOGLE_MAPS_API_KEY)
};